module.exports = __webpack_public_path__ + "static/cosysheepsuitcase-06533685c7e0a253f3215f3cc9bb8c1a.jpeg";